import { connect } from 'react-redux'
import SiteNav, {
  Values,
  Callbacks
} from '../../components/siteNav/siteNavComponent'
import { State } from '../../redux/reducers/'
import { actionCreators } from '../../redux/reducers/ui/uiReducer'

export function mapStateToProps (state: State, props): Values {
  return {
    showNavbar: state.ui.showNavbar,
    showQuizDropdown: state.ui.showQuizDropdown,
    showEndorsementDropdown: state.ui.showEndorsementDropdown,
    showAboutDropdown: state.ui.showAboutDropdown,
    siteMaintBlockGradPlanner: false
  }
}

export const propsMapping: Callbacks = {
  toggleNavbar: actionCreators.toggleNavbar,
  toggleQuizDropdown: actionCreators.toggleQuizDropdown,
  toggleEndorsementDropdown: actionCreators.toggleEndorsementDropdown,
  toggleAboutDropdown: actionCreators.toggleAboutDropdown
}

export default connect(mapStateToProps, propsMapping)(SiteNav)



// WEBPACK FOOTER //
// ./src/containers/siteNav/siteNavContainer.js